import React from 'react';
import { BrowserRouter } from 'react-router-dom';
// import { createBrowserHistory } from 'react-router-dom';

const isServer = typeof window === 'undefined';

export default function withReactRouter(App) {
    return class AppWithReactRouter extends React.Component {
        static async getInitialProps(appContext) {
            const {
                ctx: {
                    req: {
                        originalUrl,
                        locals = {},
                    },
                },
            } = appContext;
            return {
                originalUrl,
                context: locals.context || {},
            };
        }

        render() {
            // const history = createBrowserHistory({ basename: '/new-ui' });

            // console.log("withReactRoter")
            if (isServer) {
                const { StaticRouter } = require('react-router');
                return (
                    <StaticRouter
                        location={this.props.originalUrl}
                        context={this.props.context}
                    >
                        <App {...this.props} />
                    </StaticRouter>
                );
            }
            return (
                <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
                    <App {...this.props} />
                </BrowserRouter>
            );
        }
    };
};